import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesPrintPriceTagActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/PrintBarcode/PrintBarcode")
	}

	render() {
		return (
			<Activity 
				name="PrintPriceTag"
				RenderedComponent={this.RenderedComponent}
				context="PrintPriceTag"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesPrintPriceTagActivity)
